function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  className: "image-path_svg__image-path_svg__st0",
  cx: 16,
  cy: 14.8,
  r: 4.7
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "image-path_svg__image-path_svg__st0",
  d: "M37.7,26.9V9.7c0-2.4-1.9-4.3-4.3-4.3H6.6c-2.4,0-4.3,1.9-4.3,4.3v19.4l0,0l6.4-4.4c1.1-0.8,2.6-0.8,3.7,0 l4.1,2.7c1.4,0.9,3.3,0.7,4.4-0.6l5.8-7c1.3-1.6,3.7-1.6,5.1,0L37.7,26.9L37.7,26.9v3.4c0,2.4-1.9,4.3-4.3,4.3H6.6 c-2.4,0-4.3-1.9-4.3-4.3v-1.1"
});

function SvgImagePath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgImagePath;